export default "__VITE_ASSET__C$hhU4YM__"